import React, { useEffect, useLayoutEffect } from "react";
import Desings from "features/set/components/SetDesings";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificPage, hasAccessPage } from "utils/checkUserRigths";

const SetDesings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setIsInfoBtn, setSearchPlaceHolder } = useGlobalContext();
  const { setSortOptions, setSelectedSortValue, setIsEdit, isEdit, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const permission = usePermissions();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    //When user copy paste URL
    const params = new URLSearchParams(location.search);

    if (!location?.state?.name) {
      const setNumberAndCount = decodeURIComponent(params.get("setNumber"));
      const state = {
        ...location.state,
        name: [setNumberAndCount],
      };
      navigate(`${location.pathname}${location.search}`, { state: state, replace: true });
    }
    setIsInfoBtn(true);
    setIsEdit("view");
    //sorting
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
    ]);
    setSearchPlaceHolder("Search By Design Number");

    return () => {
      setIsInfoBtn(false);
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearchPlaceHolder("Search");
      setIsEdit("");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    if (isEdit === "click") {
      setSortOptions([]);
    } else {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
        { id: 10, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
      ]);
    }
  }, [isEdit]);

  return <Desings />;
};

export default SetDesings;
